<template>
  <div>
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <div style="line-height: 30px" class="about" v-loading="loading">
      <!-- <div class="fz20">东莞黄家圣幸中医医院简介</div> -->
      <div style="position: relative">
        <div class="bg1" style="">
          <div class="big-title" style="margin-bottom: 30px">
            <div class="big-name">医院概况</div>
            <div class="big-eng">
              <span class="line-left"></span>
              <span class="txt">OVERVIEW</span>
              <span class="line-right"></span>
            </div>
          </div>
          <div style="position: relative">
            <div class="jiesaotext" v-html="info.survey_desc"></div>
            <img src="../assets/shuye.png" class="shuye" alt="" />
          </div>
        </div>
        <div class="ta-center" v-if="info.survey_file">
          <video
            width="100%"
            height="100%"
            controls
            class="videoHeight"
            poster="http://sensin-his-website.oss-cn-beijing.aliyuncs.com/live/9d5aa0b6ffea2f84a405ea59745fc89f72235b5d.png"
            style="vertical-align: middle"
          >
            <source :src="`${info.survey_file}`" type="video/mp4" />
          </video>
        </div>
        <div class="bg1" style="">
          <div class="lishu" style="">一期医院介绍</div>
          <div class="jiesaotext" v-html="info.survey_first_introduce"></div>
          <div class="lishu" style="margin-top: 20px">二期医院介绍</div>
          <div class="jiesaotext" v-html="info.survey_second_introduce"></div>
          <div style="margin: 20px 0">
            <img src="@/assets/title.png" alt="" class="xcyImg" />
          </div>
          <div style="text-align: center">
            <img
              v-for="(item, index) of info.survey_images"
              :src="`${item}`"
              :key="index"
              alt=""
              class="aboutImg"
            />
          </div>
        </div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import { getmenudetail } from "@/api/common";
export default {
  name: "about",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      activeIndex: "about",
      info: { carousel: "", Mcarousel: "" },
      loading: true,
    };
  },
  mounted() {
    this.postMessage(
        "东莞黄家圣幸中医医院介绍",
        "黄家圣幸肾病专科医院是黄家圣幸集团下属肾病综合专科医院，秉承“一切为了人类健康”的使命，突出中医特色，发挥专科特长，坚持“一切以治愈为目的”的服务宗旨，已建成肾病专科、免疫性疾病专科。运用中医特效疗法，在IgA肾病、肾炎、慢性肾病领域疗效显著，在类风湿性关节炎及强直性脊柱炎领域建立诊疗优势。黄家圣幸肾病专科医院，将肩负着“推进健康中国建设，促进中医药传承与发展”的历史使命，努力创建国内一流、国际知名的现代化中医院",
        "http://www.sensin.com.cn/about",
        "http://sensin-his-website.oss-cn-beijing.aliyuncs.com/live/dcfa436bd8fbf0c0393b7c8ae645baa3e47fdbfe.jpg"
      );
    getmenudetail({ id: 3 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      if (res.data.survey_images && res.data.survey_images !== "") {
        res.data.survey_images = res.data.survey_images.split(",");
      }
      this.info = res.data;
      this.loading = false;
    });
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.about {
}

.bg2 {
  background: #fff;
}
.aboutImg {
  height: 280px;
  margin-right: 10px;
}
.lishu {
  font-family: "Microsoft YaHei";
  font-size: 26px;
  position: relative;
}
.shuye {
  position: absolute;
  bottom: -10px;
  right: -80px;
  width: 100px;
}
.about .bg1 {
  font-size: 17px;
  padding: 30px 340px 40px;
}
.about .videoHeight {
  height: 600px;
}
.about .xcyImg {
  width: 32%;
  margin-left: 10px;
}
@media screen and (max-width: 600px) {
  .about {
    width: 100%;
    margin: 0 auto 0;
  }
  .aboutImg {
    width: 90%;
    margin: 5px auto;
    height: auto;
  }
  .about .bg1 {
    font-size: 0.12rem;
    padding: 0.2rem 0.1rem;
  }
  .about .shuye {
    display: none;
  }
  .about .ta-center {
    padding: 0;
  }
  .about .videoHeight {
    height: 200px;
  }
  .about .xcyImg {
    width: 80%;
    margin: 0 10%;
  }
  .lishu {
    font-size: 0.22rem;
  }
  .jiesaotext {
    zoom: 0.9;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about.vue